<template>
  <div class="profile-page">
    <div>
    <div class="profile-page-title">Not Enough Credits</div>
      <div class="vip-desc-box">
        <div class="vip-desc">
          You don’t have enough credits to complete this action.
Please top up your credits to continue.
        </div>
      </div>
      <div class="disclaimer-btn">
        <div @click="cancelClick" class="disclaimer-btn-decline">Cancel</div>
        <div @click="topUpNow" class="disclaimer-btn-allow">Top Up Now</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  props: {
    header: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      
    };
  },
  async mounted() {
    
  },
  methods: {
    async cancelClick(){
      this.$emit("cancelClick");
    },
    
    async topUpNow() {
      this.$emit("topUpNow");
    },
    returnNewLink(){
      const { href } = this.$router.resolve({
        path: '/disclaimer'
      });
      this.logEvent('fw_home_disclaimer',{fw_module_name:'disclaimer',fw_page:'home'})
      window.open(href, '_blank');
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.profile-page {
  color: #ffffff;
  .profile-page-title{
    font-family: 'Microsoft YaHei','PingFang SC';
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    color: #3D3D3D;
  }
}
.vip-desc-box {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  .vip-desc {
    color: #3D3D3D;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    width: 419px;
    word-break: keep-all;
  }
}
.disclaimer-btn{
  display: flex;
  align-items: center;
  height: 100px;
  justify-content: space-around;
  .disclaimer-btn-decline{
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #D8D8D8;
    box-sizing: border-box;
    // border: 1px solid #4D52DE;
    cursor: pointer;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
  }
  .disclaimer-btn-allow{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #4D52DE;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
  }
}
.disclaimer-footer{
  font-family: 'Microsoft YaHei','PingFang SC';
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #000000;
  text-align: center;
  .disclaimer-footer-link{
    color: #0256FF;
    cursor: pointer;
  }
}
</style>
